import Vue from "vue";
import Router from "vue-router";
// import Home from "./views/Home.vue";
// import Settings from "./views/Settings.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      name: "Page Not Found",
      component: () => import("./views/PageNotFound.vue"),
    },
    {
      path: "/",
      name: "Login",
      component: () => import("./views/Login.vue"),
    },
    {
      path: "/home",
      name: "Home",
      component: () => import("./views/Home.vue"),
    },
    {
      path: "/pages",
      name: "Pages",
      component: () => import("./views/Pages.vue"),
    },
    {
      path: "/roles",
      name: "Roles",
      component: () => import("./views/Roles.vue"),
    },
    {
      path: "/company-roles",
      name: "Company Roles",
      component: () => import("./views/CompanyRoles.vue"),
    },
    {
      path: "/sub-company-roles",
      name: "Sub-Company Roles",
      component: () => import("./views/SubCompanyRoles.vue"),
    },
    {
      path: "/employees",
      name: "Employees",
      component: () => import("./views/Employees.vue"),
    },
    {
      path: "/companies",
      name: "Companies",
      component: () => import("./views/Companies.vue"),
    },
    {
      path: "/devices",
      name: "Devices",
      component: () => import("./views/Devices.vue"),
    },
    {
      path: "/transaction-type",
      name: "Transaction Type",
      component: () => import("./views/TransactionType.vue"),
    },
    {
      path: "/contact-number",
      name: "Contact Number",
      component: () => import("./views/ContactNumber.vue"),
    },
    {
      path: "/master-card",
      name: "Master Card",
      component: () => import("./views/MasterCard.vue"),
    },
    {
      path: "/dltb-master-card",
      name: "DLTB Master Card",
      component: () => import("./views/DLTBMasterCard.vue"),
    },
    {
      path: "/master-card-contact-number",
      name: "Master Card Contact Number",
      component: () => import("./views/MasterCardContactNumber.vue"),
    },
    {
      path: "/credit",
      name: "Credit",
      component: () => import("./views/Credit.vue"),
    },
    {
      path: "/shift-wireless",
      name: "Shift Wireless",
      component: () => import("./views/ShiftWireless.vue"),
    },
    {
      path: "/shift-sync",
      name: "Shift sync",
      component: () => import("./views/ShiftSync.vue"),
    },
    {
      path: "/transaction-wireless",
      name: "Transaction Wireless",
      component: () => import("./views/TransactionWireless.vue"),
    },
    {
      path: "/transaction-sync",
      name: "Transaction Sync",
      component: () => import("./views/TransactionSync.vue"),
    },
    {
      path: "/report/shift",
      name: "Shift report",
      component: () => import("./views/ShiftReport.vue"),
    },
    {
      path: "/report/transaction",
      name: "Transaction Report",
      component: () => import("./views/TransactionReport.vue"),
    },
    {
      path: "/card-status",
      name: "Card Status",
      component: () => import("./views/CardStatus.vue"),
    },
    {
      path: "/card-exception-report",
      name: "Card Exception Report",
      component: () => import("./views/CardExceptionReport.vue"),
    },
    {
      path: "/approve-missing-transaction",
      name: "Approve Missing Transaction",
      component: () => import("./views/ApproveMissingTransaction.vue"),
    },
    {
      path: "/final-transaction-report",
      name: "Final Transaction Report",
      component: () => import("./views/FinalTransactionReport.vue"),
    },
    {
      path: "/reprocessed-transactions",
      name: "Reprocessed Transactions",
      component: () => import("./views/ReprocessedTransactions.vue"),
    },
    {
      path: "/pre-registered-commuters",
      name: "Pre-Registered Commuters",
      component: () => import("./views/PreRegisteredCommuters.vue"),
    },
    {
      path: "/pre-registered-commuters-status",
      name: "Pre-Registered Commuters Status",
      component: () => import("./views/PreRegCommutersStatus.vue"),
    },
    {
      path: "/reconciled-transaction-report",
      name: "Reconciled Transaction Report",
      component: () => import("./views/ReconciledTransactionReport.vue"),
    },
    {
      path: "/approve-recon-transaction",
      name: "Approve Recon Transactions",
      component: () => import("./views/ApproveReconTransactions.vue"),
    },
    {
      path: "/recon",
      name: "Recon",
      component: () => import("./views/reconTransaction.vue"),
    },
    {
      path: "/report/fraudulent",
      name: "Fraudulent Report",
      component: () => import("./views/Fraudulent.vue"),
    },
    {
      path: "/report/shift-summary",
      name: "Daily Units Per Terminal",
      component: () => import("./views/DailyUnitsPerTerminal.vue"),
    },
    {
      path: "/promo",
      name: "Promo",
      component: () => import("./views/Promo.vue")
    },
    {
      path: "/sold-credit",
      name: "Sold Credit",
      component: () => import("./views/SoldCredit.vue"),
    },
    {
      path: "/credit-sold-version",
      name: "Credit Sold Version",
      component: () => import("./views/CreditSoldVersion.vue"),
    },
    {
      path: "/company-version-assignment",
      name: "Company Version Assignment",
      component: () => import("./views/CompanyVersionAssignment.vue"),
    },
    {
      path: "/sms-template",
      name: "View All Template",
      component: () => import("./views/SmsTemplate.vue"),
    },
    {
      path: "/admin",
      name: "Admin",
      component: () => import("./views/admin.vue"),
    },
    {
      path: "/shift-wireless-legacy",
      name: "Shift Wireless Legacy",
      component: () => import("./views/ShiftWirelessLegacy.vue"),
    },
    {
      path: "/report/card-registered-date",
      name: "Sold vs Same Day Registered Card",
      component: () => import("./views/RegisteredSold.vue"),
    },
    {
      path: "/report/card-sold-date",
      name: "SOLD VS. CARD REGISTRATION COUNT",
      component: () => import("./views/SoldRegister.vue"),
    },
    {
      path: "/transfer-transaction",
      name: "Transfer",
      component: () => import("./views/TransferTransactions.vue"),
    },
    {
      path: "/payment-types",
      name: "Payment Types",
      component: () => import("./views/Paymentypes.vue"),
    },
    {
      path: "/cashback",
      name: "Cashback",
      component: () => import("./views/Cashback.vue"),
    },

    // COMPANY

    {
      path: "/c/home",
      name: "Home",
      component: () => import("./views/company/Home.vue"),
    },
    {
      path: "/c/pages",
      name: "Pages",
      component: () => import("./views/company/Pages.vue"),
    },
    {
      path: "/c/roles",
      name: "Roles",
      component: () => import("./views/company/Roles.vue"),
    },
    {
      path: "/c/access-cards",
      name: "Access Cards",
      component: () => import("./views/company/AccessCards.vue"),
    },
    {
      path: "/c/employees",
      name: "Employees",
      component: () => import("./views/company/Employees.vue"),
    },
    {
      path: "/c/sub-companies",
      name: "Sub Companies",
      component: () => import("./views/company/SubCompanies.vue"),
    },
    {
      path: "/c/software-serials",
      name: "Software Serials",
      component: () => import("./views/company/SoftwareSerials.vue"),
    },
    {
      path: "/c/devices",
      name: "Devices",
      component: () => import("./views/company/Devices.vue"),
    },
    {
      path: "/c/terminals",
      name: "Terminals",
      component: () => import("./views/company/Terminals.vue"),
    },
    {
      path: "/c/terminal-servers",
      name: "Terminal Servers",
      component: () => import("./views/company/TerminalServers.vue"),
    },
    {
      path: "/c/bounds",
      name: "Bounds",
      component: () => import("./views/company/Bounds.vue"),
    },
    {
      path: "/c/fuel-stations",
      name: "Fuel Stations",
      component: () => import("./views/company/FuelStations.vue"),
    },
    {
      path: "/c/vehicle-types",
      name: "Vehicle Types",
      component: () => import("./views/company/VehicleTypes.vue"),
    },
    {
      path: "/c/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/company/VehicleLayouts.vue"),
    },
    {
      path: "/c/vehicles",
      name: "Vehicles",
      component: () => import("./views/company/Vehicles.vue"),
    },
    {
      path: "/c/violations",
      name: "Violations",
      component: () => import("./views/company/Violations.vue"),
    },
    {
      path: "/c/expenses",
      name: "Expenses",
      component: () => import("./views/company/Expenses.vue"),
    },
    {
      path: "/c/passenger-types",
      name: "Passenger Types",
      component: () => import("./views/company/PassengerTypes.vue"),
    },
    {
      path: "/c/payment-types",
      name: "Payment Types",
      component: () => import("./views/company/PaymentTypes.vue"),
    },
    {
      path: "/c/manual-types",
      name: "Manual Types",
      component: () => import("./views/company/ManualTypes.vue"),
    },
    {
      path: "/c/add-ons",
      name: "Add Ons",
      component: () => import("./views/company/AddOns.vue"),
    },

    // SUB COMPANY

    {
      path: "/c/s/home",
      name: "Home",
      component: () => import("./views/sub_company/Home.vue"),
    },
    {
      path: "/c/s/pages",
      name: "Pages",
      component: () => import("./views/sub_company/Pages.vue"),
    },
    {
      path: "/c/s/roles",
      name: "Roles",
      component: () => import("./views/sub_company/Roles.vue"),
    },
    {
      path: "/c/s/employees",
      name: "Employees",
      component: () => import("./views/sub_company/Employees.vue"),
    },
    {
      path: "/c/s/terminals",
      name: "Terminals",
      component: () => import("./views/sub_company/Terminals.vue"),
    },
    {
      path: "/c/s/bounds",
      name: "Bounds",
      component: () => import("./views/sub_company/Bounds.vue"),
    },
    {
      path: "/c/s/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/sub_company/VehicleLayouts.vue"),
    },
    {
      path: "/c/s/vehicles",
      name: "Vehicles",
      component: () => import("./views/sub_company/Vehicles.vue"),
    },
    {
      path: "/c/s/devices",
      name: "Devices",
      component: () => import("./views/sub_company/Devices.vue"),
    },
    {
      path: "/c/s/schedules",
      name: "Schedules",
      component: () => import("./views/sub_company/Schedules.vue"),
    },
    {
      path: "/c/s/add-ons",
      name: "Add Ons",
      component: () => import("./views/sub_company/AddOns.vue"),
    },
    {
      path: "/c/s/device-logs",
      name: "Device Logs",
      component: () => import("./views/sub_company/DeviceLogs.vue"),
    },
    {
      path: "/c/s/end-of-day",
      name: "End Of Day",
      component: () => import("./views/sub_company/reports/EndOfDay.vue"),
    },
    {
      path: "/c/s/remittances",
      name: "Remittances",
      component: () => import("./views/sub_company/reports/Remittances.vue"),
    },
    {
      path: "/c/s/ticket-list",
      name: "Ticket List",
      component: () => import("./views/sub_company/reports/TicketList.vue"),
    },
    {
      path: "/c/s/add-on-list",
      name: "Add On List",
      component: () => import("./views/sub_company/reports/AddOnList.vue"),
    },
    // {
    //   path: "/c/s/routes",
    //   name: "Routes",
    //   component: () => import("./views/sub_company/Routes.vue")
    // },
    // {
    //   path: "/c/s/fare-matrixes",
    //   name: "Fare Matrixes",
    //   component: () => import("./views/sub_company/FareMatrixes.vue")
    // },
    // {
    //   path: "/c/s/fuel-stations",
    //   name: "Fuel Stations",
    //   component: () => import("./views/sub_company/FuelStations.vue")
    // },
    // {
    //   path: "/c/s/violations",
    //   name: "Violations",
    //   component: () => import("./views/sub_company/Violations.vue")
    // },
    // {
    //   path: "/c/s/expenses",
    //   name: "Expenses",
    //   component: () => import("./views/sub_company/Expenses.vue")
    // },
    // {
    //   path: "/c/s/passenger-types",
    //   name: "Passenger Types",
    //   component: () => import("./views/sub_company/PassengerTypes.vue")
    // },
    {
      path: "/c/s/payment-types",
      name: "Payment Types",
      component: () => import("./views/sub_company/PaymentTypes.vue"),
    },
    {
      path: "/c/s/booking-agents",
      name: "Booking Agents",
      component: () => import("./views/sub_company/BookingAgents.vue"),
    },
    {
      path: "/c/s/booking-clients",
      name: "Booking Clients",
      component: () => import("./views/sub_company/BookingClients.vue"),
    },
    // {
    //   path: "/c/s/manual-types",
    //   name: "Manual Types",
    //   component: () => import("./views/sub_company/ManualTypes.vue")
    // },
    {
      path: "/c/s/card-settlement",
      name: "Card Settlement",
      component: () => import("./views/sub_company/CardSettlement.vue"),
    },

    // BOOKING AGENT
    {
      path: "/c/s/b/home",
      name: "Home",
      component: () => import("./views/booking_agent/Home.vue"),
    },
    {
      path: "/c/s/b/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/booking_agent/VehicleLayouts.vue"),
    },
    {
      path: "/c/s/b/routes",
      name: "Routes",
      component: () => import("./views/booking_agent/Routes.vue"),
    },
    // BOOKING AGENT
    {
      path: "/c/s/c/home",
      name: "Home",
      component: () => import("./views/booking_client/Home.vue"),
    },
    {
      path: "/c/s/c/vehicle-layouts",
      name: "Vehicle Layouts",
      component: () => import("./views/booking_client/VehicleLayouts.vue"),
    },
    {
      path: "/c/s/c/routes",
      name: "Routes",
      component: () => import("./views/booking_client/Routes.vue"),
    },
  ],
});
